'use client';

import { getStore } from '~/mobx/AppStore';

const onVotesChange = (candidateId: string, number: number) => {
    const { voteStore, ballotStore } = getStore();
    const extraVoteQuantity = Number(ballotStore.region?.regionExtraVoteQuantity) || 0;

    const updatedVotes = voteStore.votes.map((vote) => {
        if (String(vote.candidate_id) === String(candidateId)) {
            // Update the votes property
            return {
                ...vote,
                votes: (vote.votes || 0) + number,
            };
        }
        return vote;
    });

    const usedExtraVotes = updatedVotes.filter((vote) => vote.votes === 2).length;

    if (usedExtraVotes > extraVoteQuantity) {
        window.alert(`Du kan maksimalt avlegge ekstrastemme på ${extraVoteQuantity} kandidater.`);
        return;
    } else {
        voteStore.setRemainingExtraVotesQuota(extraVoteQuantity - usedExtraVotes);
        voteStore.setVotes(updatedVotes);
    }
};

export default onVotesChange;
